module.exports = "//public.zight.com/packs/media/images/star_hover-10dfec2bba85dbeab67033d8b22e8ac4.svg";